import React from 'react';
import ReactDOM from 'react-dom';
import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import * as tools from "./tools.jsx";

import {DropDownMultiSelector} from "./DropDownSelector.jsx";

var outerFormStyle =
{
  backgroundColor: '#FFFFFF',
  padding:10,
  
}

export class UserListAddMultiple extends React.Component {

    constructor(props)
    {
	    super(props);

	    this.state =
	    {
	    	data_contexts: [],
	    	contexts: [],
	    	usernames: "",
	    	errorMsg: null,
	    	isSubmitting: false,
	    	hasSubmitted: false,
	    	addedCount: 0,

	    }
	}
    readDataIfNotReadAndUserExists()
	{
     if(!this.state.hasTriedReadingData)
     {
     	const setContexts = (response) =>
     	{
     		if(response.success)
     		{
     			const contextIdsAndNames = response.result.map((con)=>{
     				return {id:con.context_id, name: con.name};
     			});

     			this.setState({data_contexts: contextIdsAndNames})
     		}
     	}
        this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
           setContexts, false);

        this.setState({hasTriedReadingData:true});
     }
	}
   
	componentWillMount()
	{
		this.readDataIfNotReadAndUserExists();
	}

	componentWillUpdate()
	{
		this.readDataIfNotReadAndUserExists();
	}

	namesChanged(e)
	{
	    console.log("Changed text to: " + e.target.value);
	    this.setState({usernames: e.target.value});
	}

	contextsChanged(contexts)
	{
		console.log("COntexts: ", contexts);
		this.setState({contexts: contexts});
	}

	clickedCreate()
	{
		const namesNoTrim = this.state.usernames.split(",");
		const trimmedNames = namesNoTrim.map((n)=>{return n.trim()});
		console.log("Trimmed names: ", trimmedNames);
		
		this.setState({hasSubmitted:true, isSubmitting: true});

		var error = "";
		var addedCount = 0;
		var respondedCount = 0;
		var ommitted = "";
		for(var i = 0; i < trimmedNames.length; i++)
		{
			const name = trimmedNames[i];

			const nameAddedCB = (response)=>
			{
				respondedCount += 1;

				if(response.success)
				{
					console.log("Sucess: " + name);
					addedCount += 1;
					this.setState({addedCount:addedCount});
				}
				else
				{
					console.log("Failed: " + name);
					ommitted += name + ",";
					error += response.error.join(",");
					this.setState({errorMsg:error});
				}

				if(respondedCount >= trimmedNames.length)
				{
					this.props.appCallbacks.popModal();
					this.props.onDoneAdding();
					this.setState({isSubmitting:false});
					this.setState({usernames: ommitted});
				}

			}

			const userObj = {
				email:name,
				name: name,
				password: tools.makeid(),
				contexts: this.state.contexts,
				role: 1,
			}

			this.props.appCallbacks.performAjaxRequest("users", "POST", userObj,
           		nameAddedCB, false);
		}

		this.setState({isSubmitting:true});
	}

	clickedCancel()
	{
		this.props.appCallbacks.popModal();
	}

   render()
   {
   		
   		return (
      		<div style={outerFormStyle}>
      			<p>userNames (comma-separated)</p>
      			<textarea rows={24} cols={32} onChange={this.namesChanged.bind(this)} />
      			<p>Accessible Contexts </p>
      			<DropDownMultiSelector onChange={this.contextsChanged.bind(this)}
      				objects={this.state.data_contexts} value={this.state.contexts}/>

      			<div>
      				<div style={{clear:'both', height:"40px"}}></div>
		            {this.state.hasSubmitted ? null : <button style={{float:'left'}} onClick={this.clickedCreate.bind(this)}>create</button>}
		            {this.state.isSubmitting ? null : <button style={{float:'right'}} onClick={this.clickedCancel.bind(this)}>cancel</button>}
		            <div style={{clear:'both', height:"40px"}}></div>
		            {this.state.errorMsg ? <span><h2>Error: </h2>{this.state.errorMsg}</span>  : null}

		        </div>
			</div>
      	)
   }
}



// WEBPACK FOOTER //
// ./js/userListAddMultiple.jsx